<template>
  <div>
    <MainHeader v-if="!isHomePage" />
    <router-view />
    <MainFooter />
    <public-cookies v-if="isMounted" />
  </div>
</template>

<script>
import MainHeader from '@/components/MainHeader'
import MainFooter from '@/components/MainFooter'
import {useRouter} from 'vue-router/dist/vue-router'
import {useRoute} from 'vue-router'
import {computed, onBeforeUnmount, ref, onMounted} from 'vue'
import PublicCookies from "@/components/public-cookies";
export default {
  name: 'App',
  components: {PublicCookies, MainFooter, MainHeader},

  setup() {
    const router = useRouter()
    const route = useRoute()
    const isMounted = ref(false)

    const isHomePage = computed(() => {
      return route.name === 'home' || route.name === 'news'
    })

    function messageCB(message) {
      if (message.data.type === 'order-manage') {
        router.push({ name: 'order-edit', params: { id: message.data.other.id }, query: { phoneNumber: message.data.other.phone } })
      } else if (message.data.type === 'order-create') {
        router.push({ name: 'order-create', query: message.data.other?.query })
      }
    }

    onMounted(() => {
      isMounted.value = true
      window.addEventListener('message', messageCB)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('message', messageCB)
    })

    return {
      isHomePage,
      isMounted
    }
  }
}
</script>

<style>
</style>
